<!-- eslint-disable vue/no-v-html -->
<template>
  <!--  spanのforはsctv用  -->
  <span
    :for="id"
    class="btn-radio"
    @click="sendClickEvent(trackingName)"
    @mousedown="sendMousedownEvent(trackingName)"
    @mouseover="sendMouseoverEvent(trackingName)"
    @mouseout="sendMouseoutEvent(trackingName)"
  >
    <input
      :id="id"
      v-model="localValue"
      type="radio"
      class="radiobtn"
      :name="name"
      :value="value"
      :tabindex="tabindex"
      :disabled="disabled"
      @change="sendChangeEvent(trackingName)"
      @focus="onFocus"
      @blur="onBlur"
      @input="sendInputEvent(trackingName)"
      @keydown="sendKeydownEvent(trackingName)"
      @keyup="sendKeyupEvent(trackingName)"
    />
    <label v-if="label" :class="[variant]" :for="id" v-html="label"></label>
    <label v-else :for="id" :class="[variant]"><slot></slot></label>
  </span>
</template>

<script>
import {
  sendMousedownEvent,
  sendMouseoverEvent,
  sendMouseoutEvent,
  sendInputEvent,
  sendKeydownEvent,
  sendKeyupEvent,
  sendChangeEvent,
  sendFocusEvent,
  sendBlurEvent,
  sendClickEvent,
} from "@/utils/FormEvent";

export default {
  name: "BtnRadio",
  props: {
    variant: { type: String, default: "" },
    size: { type: String, default: "" },
    name: { type: String, default: "" },
    label: { type: String, default: "" },
    id: { type: String, default: "" },
    tabindex: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    modelValue: { type: String, default: "" },
    value: { type: String, default: "" },
    trackingName: { type: String, default: "" },
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup() {
    return {
      sendMousedownEvent,
      sendMouseoverEvent,
      sendMouseoutEvent,
      sendInputEvent,
      sendKeydownEvent,
      sendKeyupEvent,
      sendChangeEvent,
      sendFocusEvent,
      sendBlurEvent,
      sendClickEvent,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    onFocus(e) {
      this.sendFocusEvent(this.trackingName);
      this.$emit("focus", e);
    },
    onBlur(e) {
      this.sendBlurEvent(this.trackingName);
      this.$emit("blur", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-radio {
  text-align: left;
  display: inline-block;
  width: calc(50% - 5px);
  @include mq-up(md) {
    width: 161px;
  }
  // ラジオボタン
  > .radiobtn {
    display: none;
  }
  > .radiobtn + label {
    @include flex(flex, flex-start, center, row, nowrap);
    padding-left: 30px;
    position: relative;
    margin-right: 20px;
    border: 1px solid $secondary;
    border-radius: 10px;
    background-color: $white;
    height: 55px;
    width: 100%;
    cursor: pointer;
    @include mq-up(md) {
      height: 62px;
      padding-right: 1em;
    }
  }
  > .radiobtn + label::before {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 8px);
    left: 10px;
    width: 15px;
    height: 15px;
    border: 1px solid $primary;
    border-radius: 50%;
    @include mq-up(md) {
      top: calc(50% - 7px);
    }
  }
  > .radiobtn:checked + label {
    border: 1px solid $primary;
  }
  > .radiobtn:checked + label::after {
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 5px);
    left: 13px;
    width: 9px;
    height: 9px;
    background: $primary;
    border-radius: 50%;
    @include mq-up(md) {
      top: calc(50% - 4px);
    }
  }
}
.btn-radio {
  &._font-sm {
    > .radiobtn + label {
      font-size: 14px;
    }
  }
  &.disabled {
    pointer-events: none;
    > .radiobtn + label {
      background-color: #f5f5f5;
      color: #aaaaaa;
    }
    > .radiobtn + label::before {
      border: 1px solid #aaaaaa;
    }
  }
}

@include mq-down(xs) {
  .btn-radio {
    .-xs {
      font-size: 12px;
    }
  }
}
</style>
